"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const debounce_1 = __importDefault(require("lodash/debounce"));
const client_1 = require("@apollo/client");
//
// assets
//
const queryDefinitions_1 = require("queryDefinitions");
const tokenHeader_1 = require("tokenHeader");
//
// styles
//
const StyledButton_1 = require("./StyledButton");
const StyledButtonCard_1 = require("./StyledButtonCard");
const StyledCard_1 = require("./StyledCard");
const StyledContainer_1 = require("./StyledContainer");
const StyledIcon_1 = require("./StyledIcon");
const StyledMenu_1 = require("./StyledMenu");
const MalomoButton_1 = require("components/Dashboard/MalomoButton");
//
// components
//
const Account_1 = __importDefault(require("components/general/Account"));
const AccountModal_1 = __importDefault(require("components/general/AccountModal"));
//
// modules
//
const ModalContainer_1 = __importDefault(require("components/general/ModalContainer"));
const usePaginatedSearch_1 = __importDefault(require("components/usePaginatedSearch"));
const LocalAccount_1 = __importDefault(require("LocalAccount"));
const AccountContext_1 = require("contexts/AccountContext");
const Dropdown = (props) => {
    const { setAccount } = (0, AccountContext_1.useAccount)();
    const [settingsVisible, setSettingsVisible] = react_1.default.useState(false);
    const [showModal, setShowModal] = react_1.default.useState(false);
    const navigate = (0, react_router_dom_1.useNavigate)();
    const account = JSON.parse(localStorage.getItem('account') || '{ "name": "MockAccount" }');
    const wrapperRef = (0, react_1.useRef)(null);
    function detectClick(ref) {
        (0, react_1.useEffect)(() => {
            function handleClickOutside(event) {
                if (ref.current && !ref.current.contains(event.target)) {
                    setSettingsVisible(false);
                }
            }
            document.addEventListener('mousedown', handleClickOutside);
            return () => {
                document.removeEventListener('mousedown', handleClickOutside);
            };
        }, [ref]);
    }
    detectClick(wrapperRef);
    function handleLogout() {
        props.onLogout();
        navigate('/login', { replace: true });
    }
    function handleSettingsLink() {
        setSettingsVisible(false);
        navigate('/settings/profile');
    }
    function handleKeypress(e, func) {
        if (e.keyCode === 13) {
            func();
        }
    }
    function handleToggleDropdown() {
        setSettingsVisible((current) => !current);
    }
    function handleToggleModal() {
        setShowModal((current) => !current);
        setSettingsVisible(false);
    }
    function handleSelectAccount(newAccount) {
        setAccount(newAccount.node);
        // LocalAccount should no longer be necessary when we start using the
        // account context, but for now there's some duplication
        LocalAccount_1.default.set(newAccount.node);
        handleToggleModal();
    }
    const pageCount = 10;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'data' does not exist on type '((options?... Remove this comment to see the full error message
    const [getFirstPageAccounts, { data, fetchMore }] = (0, tokenHeader_1.useAuthedLazyQuery)(queryDefinitions_1.GET_ACCOUNTS);
    const { data: userData } = (0, client_1.useQuery)(queryDefinitions_1.GET_USER);
    (0, react_1.useEffect)(() => {
        // @ts-expect-error ts-migrate(2349) FIXME: This expression is not callable.
        getFirstPageAccounts({ variables: { first: pageCount } });
    }, []);
    const { handleSearch: executeSearch, handleLoadNext } = (0, usePaginatedSearch_1.default)(fetchMore, 'accounts', data);
    const handleSearch = (0, react_1.useCallback)(
    // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
    (0, debounce_1.default)((e) => executeSearch(e.target.value), 1000, true), [fetchMore]);
    return (react_1.default.createElement(StyledContainer_1.StyledContainer, { className: 'dropdown', ref: wrapperRef },
        react_1.default.createElement(ModalContainer_1.default, { display: showModal, onToggleModal: handleToggleModal },
            react_1.default.createElement(AccountModal_1.default, { accounts: data ? data.accounts.edges : [], handleLoadNext: handleLoadNext, handleSearch: handleSearch, hasMore: data && data.accounts.pageInfo.hasNextPage, onSelectAccount: handleSelectAccount, onToggleModal: handleToggleModal, userIsAdmin: userData && userData.currentUser.admin })),
        react_1.default.createElement(StyledButton_1.StyledButton, { "aria-expanded": 'false', "aria-haspopup": 'true', className: 'btn btn-primary dropdown-toggle-button', "data-toggle": 'dropdown', onClick: handleToggleDropdown, type: 'button' },
            react_1.default.createElement(Account_1.default, { accountName: account.name, userName: userData ? userData.currentUser.name : 'User Name' })),
        react_1.default.createElement(StyledMenu_1.StyledMenu, { className: `dropdown-menu dropdown-menu-car ${settingsVisible ? 'show' : ''}` },
            react_1.default.createElement(StyledCard_1.StyledCard, { className: 'card-body change-account', onClick: handleToggleModal, onKeyDown: (e) => handleKeypress(e, handleToggleModal), tabIndex: 0 },
                react_1.default.createElement(StyledIcon_1.StyledIcon, { className: 'fe fe-users' }),
                "Switch Accounts"),
            react_1.default.createElement(StyledCard_1.StyledCard, { className: 'card-body settings-link', onClick: handleSettingsLink, onKeyDown: (e) => handleKeypress(e, handleSettingsLink), tabIndex: 0 },
                react_1.default.createElement(StyledIcon_1.StyledIcon, { className: 'fe fe-settings' }),
                "Settings"),
            react_1.default.createElement(StyledButtonCard_1.StyledButtonCard, { className: 'card-body' },
                react_1.default.createElement(MalomoButton_1.MalomoButton, { className: 'sign-out', onClick: handleLogout }, "Sign Out")))));
};
exports.default = Dropdown;
